// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"6aae2220","203":"6aae2220","238":"6aae2220","458":"4a796802","553":"351042fa","678":"6aae2220"}[chunkId] + ".chunk.css";
};